var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance)?_c('editor',{on:{"cancel":function($event){return _vm.cancel()},"saved":function($event){return _vm.saved($event)}},model:{value:(_vm.instance),callback:function ($$v) {_vm.instance=$$v},expression:"instance"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }